var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReviewDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29297 19.5938H7.21875C5.66794 19.5938 4.40625 18.3321 4.40625 16.7812V7.21875C4.40625 5.66794 5.66794 4.40625 7.21875 4.40625H13.6875C15.2383 4.40625 16.5 5.66794 16.5 7.21875V12.3516C16.5 12.7399 16.8148 13.0547 17.2031 13.0547C17.5915 13.0547 17.9062 12.7399 17.9062 12.3516V7.21875C17.9062 4.89253 16.0137 3 13.6875 3H7.21875C4.89253 3 3 4.89253 3 7.21875V16.7812C3 19.1075 4.89253 21 7.21875 21H9.29297C9.6813 21 9.99609 20.6852 9.99609 20.2969C9.99609 19.9085 9.6813 19.5938 9.29297 19.5938Z",
    fill: "#004E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4023 5.8125C11.014 5.8125 10.6992 6.12729 10.6992 6.51562V7.71094C10.6992 9.0679 11.8032 10.1719 13.1602 10.1719H14.3555C14.7438 10.1719 15.0586 9.85709 15.0586 9.46875C15.0586 9.08041 14.7438 8.76562 14.3555 8.76562H13.1602C12.5786 8.76562 12.1055 8.29249 12.1055 7.71094V6.51562C12.1055 6.12729 11.7907 5.8125 11.4023 5.8125Z",
    fill: "#004E5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1341 15.9698C19.0026 15.1853 17.3011 14.25 15.6211 14.25C13.9411 14.25 12.2396 15.1853 11.1081 15.9698C10.5659 16.3458 10.2422 16.9645 10.2422 17.625C10.2422 18.2855 10.5659 18.9042 11.1081 19.2802C12.2396 20.0647 13.9411 21 15.6211 21C17.3011 21 19.0026 20.0647 20.1341 19.2802C20.6763 18.9042 21 18.2855 21 17.625C21 16.9645 20.6763 16.3458 20.1341 15.9698ZM19.3329 18.1245C18.3662 18.7948 16.9376 19.5938 15.6211 19.5938C14.3046 19.5938 12.876 18.7948 11.9093 18.1245C11.7435 18.0095 11.6484 17.8275 11.6484 17.625C11.6484 17.4225 11.7435 17.2405 11.9093 17.1255C12.876 16.4552 14.3046 15.6562 15.6211 15.6562C16.9376 15.6562 18.3662 16.4552 19.3329 17.1255C19.4987 17.2405 19.5938 17.4225 19.5938 17.625C19.5938 17.8275 19.4987 18.0095 19.3329 18.1245Z",
    fill: "#004E5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6562 18.5215C16.1514 18.5215 16.5527 18.1201 16.5527 17.625C16.5527 17.1299 16.1514 16.7285 15.6562 16.7285C15.1611 16.7285 14.7598 17.1299 14.7598 17.625C14.7598 18.1201 15.1611 18.5215 15.6562 18.5215Z",
    fill: "#004E5E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewDoc);
export default __webpack_public_path__ + "static/media/ReviewDoc.e81e5138cdc906fc8a8e69bfb80e5d5d.svg";
export { ForwardRef as ReactComponent };